
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { User } from 'lucide-react';

interface NameFieldProps {
  name: string;
  setName: (name: string) => void;
  error?: string;
}

const NameField = ({ name, setName, error }: NameFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="name">
        Full Name <span className="text-red-500">*</span>
      </Label>
      <div className="relative">
        <User className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
        <Input
          id="name"
          type="text"
          placeholder="John Doe"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className={`pl-10 ${error ? 'border-red-500' : ''}`}
        />
      </div>
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </div>
  );
};

export default NameField;
